<div class="dialog-select-root" *transloco="let t">
  <button
    id="close-dialog-icon"
    (click)="onFailClick()"
    mat-icon-button
    class="close-button"
  >
    <mat-icon>cancel</mat-icon>
  </button>
  <app-header id="dialog-modal-title">
    {{ t('change-admin-role') }}
  </app-header>
  <div mat-dialog-content>
    <app-paragraph id="dialog-modal-content" class="dialog-modal-content">
      {{ t('change-admin-role-description', {selectedRole: getRoleLabel()}) }}
    </app-paragraph>
    <span>
      {{ t('change-admin-role-obs') }}
    </span>
  </div>
  <app-multi-select
    #regionMultiSelect
    [options]="availableRegions"
    [initialMultiData]="mappedRegions"
    [isMultiselector]="true"
    [entity]="'Regions'"
    (valueChange)="handleRegionChange($event)"
    ></app-multi-select>
  <div mat-dialog-actions>
    <app-primary-button
      v2Outlined
      id="fail-dialog-btn"
      mat-button
      (click)="onFailClick()"
    >
      {{ t('cancel') }}
    </app-primary-button>
    <app-primary-button
      v2Full
      class="success-button"
      id="success-dialog-btn"
      mat-button
      (click)="onSuccessClick()"
      [disabled]="!regionMultiSelect.formControl.value"
    >
      {{ t('change') }}
    </app-primary-button>
  </div>
</div>
